import { HttpInterceptor, HttpRequest } from '@angular/common/http/';
import {HttpEvent, HttpHandler} from '@angular/common/http';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";

@Injectable()
export class ContentTypeInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers = req.headers.set('Accept', 'application/json') // For all
        if (req.method == 'POST' || req.method == 'PUT' || req.method == 'DELETE') { // For POST / PUT / DELETE
            const changedReq = req.clone({
                headers: headers.set('Content-Type', 'application/json')
            });
            return next.handle(changedReq);
        }
        return next.handle(req);
    }

}


// WEBPACK FOOTER //
// ./src/interceptors/content-type.interceptor.ts